/* ═══ Messieh Orthopedic — Theme JS ═══ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Mobile Nav ── */
  const toggle = document.querySelector('.mobile-toggle');
  const drawer = document.querySelector('.mobile-nav-drawer');
  const overlay = document.querySelector('.mobile-nav-overlay');

  function openNav() {
    toggle && toggle.classList.add('active');
    drawer && drawer.classList.add('active');
    overlay && overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    toggle && toggle.classList.remove('active');
    drawer && drawer.classList.remove('active');
    overlay && overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (toggle) toggle.addEventListener('click', function () {
    drawer && drawer.classList.contains('active') ? closeNav() : openNav();
  });
  if (overlay) overlay.addEventListener('click', closeNav);
  if (drawer) drawer.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', closeNav);
  });

  /* ── FAQ Accordion ── */
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      this.parentElement.classList.toggle('open');
    });
  });
  var firstFaq = document.querySelector('.faq-item');
  if (firstFaq) firstFaq.classList.add('open');

  /* ── Scroll Animations ── */
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.classList.add('visible');
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.anim').forEach(function (el) { obs.observe(el); });
  } else {
    document.querySelectorAll('.anim').forEach(function (el) { el.classList.add('visible'); });
  }
});
